export const audiences = {
  audienceDetail: {
    audience: 'Audience',
    audienceCreationState: {
      audienceCreationFailed: 'Audience creation failed',
      creatingAudiencePersona: 'Creating audience...',
      deleteAndTryAgain: 'Delete and try again',
      somethingWentWrongWhileGenerating:
        'Something went wrong while generating this audience. Try creating it again.',
      thisUsuallyTakesAMinute:
        'This usually takes a minute. You can leave this page and come back later.',
    },
    audienceHeader: {
      backToAudiences: 'Back to Audiences',
      backToKnowledgeHub: 'Back to Knowledge Hub',
      edit: 'Edit',
      startConversation: 'Start Conversation',
    },
    audienceHeaderV2: {
      audiences: 'Audiences',
      defaultCannotBeEdited: 'Default personas cannot be edited',
      edit: 'Edit',
      knowledge: 'Knowledge',
      startConversation: 'Start conversation',
    },
    audienceNotFound: 'Audience Not Found',
    couldnTLoadAudience: "Couldn't load audience",
    iWantToSpeakWith: 'I want to speak with {{persona}}',
    loading: 'Loading...',
    personaExportButton: {
      download: 'Download',
      downloadPersonaAsPdf: 'Download persona as PDF',
      failedToDownloadPersona: 'Failed to download persona',
      preparingYourDownloadThis: 'Preparing your download, this may take a moment…',
    },
    tryAgain: 'Try again',
    unnamedAudience: 'Unnamed Audience',
  },
  audienceFlowWidget: {
    audienceFlowThumbnail: {
      audience: 'Audience',
      persona: 'Persona',
    },
    audienceFlowWidget: {
      audienceOverview: 'Audience Overview',
      back: 'Back',
      iWantToSpeakWith: 'I want to speak with {{persona}}',
      startConversation: 'Start Conversation',
    },
    behindTheAnswerWidget: {
      interview: 'Interview - {{persona}}',
      basedOnWhatPersonaCares: 'Based on what persona cares about',
      dataBehindTheAnswer: 'Data behind the answer',
    },
    biographySection: {
      ageRange: 'Age range',
      hobbies: 'Hobbies',
      incomeLevel: 'Income level',
      locations: 'Locations',
      notSpecified: 'Not specified',
      percentOfMarket: '{{percent}}% of market',
      profileImage: 'Profile image - {{name}}',
    },
    caresAboutSection: {
      brandRelationship: 'Brand Relationship',
      caresAbout: 'Cares about',
      currentPerception: 'Current Perception',
      desiredRelationship: 'Desired Relationship',
      productRelationship: 'Product Relationship',
      whatTheyDislike: 'What They Dislike',
      whatTheyLike: 'What They Like',
    },
    didYouKnowSection: {
      didYouKnow: 'Did you know?',
    },
    mainTakeAwaySection: {
      mainTakeAway: 'Main take-away',
    },
    mediaConsumptionSection: {
      audience: 'Audience %',
      description: 'Description',
      donutChartShowingPlatformUsage: 'Donut chart showing platform usage distribution',
      index: 'Index',
      indexHint:
        'Affinity against the general population, where 100 is average. An index of 145 means this audience is 1.45x as likely.',
      mediaConsumption: 'Media Consumption',
      reach: 'Reach %',
      section: {
        channels: 'Channels',
        contentTypes: 'Content Types',
        influencers: 'Influencers',
        mediaConsumption: 'Media Consumption',
        platforms: 'Platforms',
      },
      sourceCreatorPartnershipDatabase: 'Source: Creator partnership database',
      topChannels: 'Top Channels',
      topContentTypes: 'Top Content Types',
      topInfluencers: 'Top Influencers',
      topPlatforms: 'Top Platforms',
    },
    personaDetailsSection: {
      aspirations: 'Aspirations',
      behaviors: 'Behaviors',
      coreValues: 'Core Values',
      keyInterests: 'Key Interests',
      lifestyle: 'Lifestyle',
      needsMotivations: 'Needs & Motivations',
      painPoints: 'Pain Points',
      personaDetails: 'Persona details',
      psychographics: 'Psychographics',
    },
    personaList: {
      createPersonasInTheKnowledge:
        'Create personas in the Knowledge Hub to start interviewing your audience',
      noPersonasFound: 'No personas found',
      whoWouldYouLikeTo: 'Who would you like to interview?',
    },
    personaListBlock: {
      startConversation: 'Start conversation',
      viewDetails: 'View details',
    },
    sourcesSection: {
      geminiLogo2025: 'Gemini logo, 2025',
      openAiDeepResearchLogo: 'Open AI Deep Research logo',
      sources: 'Sources',
    },
    topInsightsSection: {
      topInsights: 'Top Insights',
    },
  },
  audienceInterview: {
    downloadDropdown: {
      conversationAsPdf: 'Conversation as PDF',
      download: 'Download',
      exporting: 'Exporting...',
      personaAsPdf: 'Persona as PDF',
    },
    interviewPersonasPanel: {
      backToAudiences: 'Back to Audiences',
      personasOverview: 'Personas Overview',
      whoWouldYouLikeTo: 'Who would you like to interview?',
    },
    interviewWelcomeMessage: {
      moderator: 'Moderator',
      welcomeToTheInterviewSession:
        "Welcome to the Interview session! I'll simulate a one-on-one conversation with an audience representative. Configure the audience profile and brand context in the settings panel, then tell me what you want to learn.",
    },
    useInterviewDownload: {
      failedToDownloadConversation: 'Failed to download conversation',
      failedToDownloadPersona: 'Failed to download persona',
      preparingYourDownload: 'Preparing your download, this may take a moment…',
    },
  },
  audiences: {
    aiPromptPanel: {
      send: 'Send',
    },
    audiences: 'Audiences',
    audiencesActions: {
      createPersona: 'Create Persona',
    },
    audiencesContent: {
      noResultsForPleaseCheck:
        'No results for "{{search}}". Please check your search query and try again.',
      thisActionCannotBeUndone:
        'This action cannot be undone. The persona and all associated data will be permanently deleted.',
    },
    personaRepeaterRows: {
      removeRow: 'Remove row {{row}}',
    },
    personaTagField: {
      addValue: 'Add "{{value}}"',
      noOptions: 'No matches',
    },
    createPersonaSheet: {
      back: 'Back',
      continue: 'Continue',
      createAudience: 'Create audience',
    },
    audiencesContentV2: {
      couldntLoad: "Couldn't load audiences",
      createAudience: 'Create audience',
      emptyDescription:
        "Audiences let you bring your brand to life by defining who you're talking to. Build brand-first personas to have meaningful conversations, validate ideas and concepts, and explore decisions from your audience's point of view.",
      emptyTitle: 'Start creating your first audience',
      noResultsDescription: 'Try a different search or clear the filters.',
      noResultsTitle: 'No audiences match these filters',
      tryAgain: 'Try again',
    },
    audiencesGridV2: {
      defaultCannotBeDeleted: 'Default personas cannot be deleted',
      defaultCannotBeEdited: 'Default personas cannot be edited',
      delete: 'Delete',
      edit: 'Edit',
      trait: '{{label}} · {{multiplier}}×',
    },
    audiencesTableV2: {
      actions: 'Actions',
      defaultCannotBeDeleted: 'Default personas cannot be deleted',
      defaultCannotBeEdited: 'Default personas cannot be edited',
      lastRefreshed: 'Last refreshed',
      name: 'Segment name',
      status: 'Status',
      topic: 'Topic',
      traits: 'Most distinctive traits',
      untitled: 'Untitled audience',
    },
    audiencesV2: {
      knowledge: 'Knowledge',
    },
    audiencesToolbarV2: {
      createAudience: 'Create audience',
      gridView: 'Grid view',
      listView: 'List view',
      searchAudiences: 'Search audiences...',
      searchAudiencesLabel: 'Search audiences',
      status: {
        failed: 'Failed',
        label: 'Status',
        processing: 'In progress',
        ready: 'Ready',
      },
      viewMode: 'View mode',
    },
    audienceStatusChip: {
      failed: 'Failed',
      inProgress: 'In progress',
      ready: 'Ready',
    },
    basicInformationSection: {
      age: 'Age',
      annualIncome: 'Annual Income',
      basicInformation: 'Basic Information',
      city: 'City',
      communicationPreference: 'Communication Preference',
      country: 'Country',
      demographics: 'Demographics',
      eGBudgetSavvyStudent: 'e.g. Budget-Savvy Student',
      eGEcoTechAspirers: 'e.g. Eco & Tech Aspirers',
      eGMarketingManager: 'e.g. Marketing Manager',
      eGMarriedWith2: 'e.g. Married with 2 children',
      essentialDetailsAboutThePersona:
        'Essential details about the audience including location, demographics and communication preference',
      familyComposition: 'Family Composition',
      gender: 'Gender',
      iWantProductsThatMatch:
        'I want products that match my values and make me feel proud to share them with my friends.',
      location: 'Location',
      profession: 'Profession',
      quote: 'Quote',
      segment: 'Segment',
      selectAge: 'Select age',
      selectGender: 'Select gender',
      selectToneOrTypeTo: 'Select tone or type to add new ones',
      state: 'State',
      title: 'Title',
      toneOfVoice: 'Tone of Voice',
    },
    biographyItems: {
      career: 'Career',
      lifestyle: 'Lifestyle',
      socialMedia: 'Social Media',
      values: 'Values',
    },
    biographySection: {
      biography: 'Biography',
      biographyItems: 'Biography items',
      description: 'Description',
      interests: 'Interests',
      item: 'Item',
      typeAndPressEnterTo: 'Type and press Enter to add tags',
    },
    caresAboutSection: {
      addItem: 'Add item',
      caresAbout: 'Cares about',
      description: 'Description',
      item: 'Item',
      removeItem: 'Remove item',
    },
    channelsSection: {
      channel: 'Channel',
      channels: 'Channels',
      description: 'Description',
      share: 'Share (%)',
    },
    createPersonaForm: {
      back: 'Back',
      continue: 'Continue',
      createPersona: 'Create persona',
      fillPersonaInformation: 'Fill audience information',
      setSpaceVisibility: 'Set space visibility',
    },
    customRequirementsSection: {
      anyOtherSpecificRequirementsOr:
        'Any other specific requirements or characteristics unique to this audience',
      customRequirement: 'Custom Requirement',
      customRequirements: 'Custom Requirements',
      enterCustomRequirement: 'Enter custom requirement',
    },
    demographicsSection: {
      age: 'Age',
      annualIncome: 'Annual income',
      demographics: 'Demographics',
      education: 'Education',
      eGEarlyCareerProfessional: 'e.g. Early-career professional',
      eGLivesWithA: 'e.g. Lives with a partner, no kids yet',
      eGUniversityDegree: 'e.g. University degree',
      eGUrbanLivesIn: 'e.g. Urban, lives in Austin (car-light lifestyle)',
      familyComposition: 'Family composition',
      gender: 'Gender',
      lifeStage: 'Life stage',
      location: 'Location',
      selectAge: 'Select age',
      selectGender: 'Select gender',
    },
    editPersonaForm: {
      age: 'Age',
      annualIncome: 'Annual income',
      biography: 'Biography',
      cancel: 'Cancel',
      caresAbout: 'Cares about',
      channels: 'Channels',
      defaultPersonasCannotBeEdited: 'Default audiences cannot be edited',
      detailVideo: 'Detail video',
      editPersona: 'Edit audience',
      education: 'Education',
      familyComposition: 'Family composition',
      gains: 'Gains',
      gender: 'Gender',
      gwiAudience: 'GWI audience',
      interests: 'Interests',
      lifeStage: 'Life stage',
      location: 'Location',
      pains: 'Pains',
      personaInformation: 'Audience information',
      personaTitle: 'Audience title',
      profileImage: 'Profile image',
      profileMedia: 'Profile media',
      quote: 'Quote',
      saveChanges: 'Save changes',
      segment: 'Segment',
      spaceVisibility: 'Space visibility',
      thumbnailVideo: 'Thumbnail video',
    },
    gainsSection: {
      addGain: 'Add gain',
      description: 'Description',
      gains: 'Gains',
      removeGain: 'Remove gain',
    },
    gwiLinkSection: {
      eG06e243bcD5244d16: 'e.g. 06e243bc-d524-4d16-aff5-62174dc673f4',
      gwiAudience: 'GWI audience',
      gwiAudienceId: 'GWI audience ID',
      pasteTheGwiAudienceUuid: 'Paste the GWI audience UUID to link this audience.',
    },
    painsSection: {
      addPain: 'Add pain',
      description: 'Description',
      pains: 'Pains',
      removePain: 'Remove pain',
    },
    personaActionsCell: {
      defaultCannotBeDeleted: 'Default personas cannot be deleted',
      defaultCannotBeEdited: 'Default personas cannot be edited',
      delete: 'Delete',
      edit: 'Edit',
      moreActions: 'More actions',
    },
    personaFieldsConstants: {
      ageUnder18: 'Under 18',
      eG7500010000: 'e.g. $75,000 - $100,000',
      female: 'Female',
      male: 'Male',
      nonBinary: 'Non-binary',
      other: 'Other',
    },
    profileImageSection: {
      createdAt: 'Created at',
      download: 'Download',
      downloadImage: 'Download image',
      modelUsed: 'Model used',
      noImage: 'No image',
      profileImage: 'Profile image',
      promptUsed: 'Prompt used',
      reGenerateImage: 'Re-generate image',
      uploadedAt: 'Uploaded at',
      uploadFile: 'Upload file',
    },
    profileMediaTab: {
      addSpecificInstructionsForThe:
        'Add specific instructions for the detail video (e.g. voice accent, body movement, gestures, facial expressions). This prompt only applies to the detail video — the thumbnail video will regenerate with default settings.',
      describeThePhysicalTraitsYou:
        'Describe the physical traits you want for this audience (e.g. hair style, skin tone, facial features, body type). Position, framing and lighting are predefined styles and cannot be edited.',
      describeYourPersonaImage: 'Describe your audience image...',
      describeYourPersonaVideos: 'Describe your audience videos...',
      donTGenerate: "Don't generate",
      generateVideos: 'Generate videos',
      imageGeneratedSuccessfully: 'Image generated successfully',
      imageGenerator: 'Image Generator',
      imageUploadedSuccessfully: 'Image uploaded successfully',
      reGenerateImage: 'Re-generate image',
      reGenerateVideos: 'Re-generate videos',
      videoGenerator: 'Video Generator',
      wouldYouLikeToAutomatically:
        'Would you like to automatically generate thumbnail and detail videos based on this new image?',
    },
    requiredFieldsLegend: {
      requiredFields: 'Required fields',
    },
    segmentDetailsSection: {
      addADetailedDescriptionOf: 'Add a detailed description of the segment',
      interests: 'Interests',
      segment: 'Segment',
      segmentDescription: 'Segment description',
      segmentDetails: 'Segment details',
      selectInterestsOrTypeAnd: 'Select interests or type and press Enter to add new ones',
      theSegmentWhichThisPersona:
        'The segment which this audience belongs to and key topics and brands of interest that resonate with this audience',
      topicsOfInterest: 'Topics of interest',
      typeToAddANew: 'Type to add a new segment or select an existing one',
    },
    spaceVisibilitySection: {
      setTheSpaceVisibilityFor: 'Set the space visibility for this audience',
      spaceVisibility: 'Space Visibility',
    },
    useCreatePersonaForm: {
      audienceCreationStarted: 'Audience creation started',
      personaFailedToCreate: 'Audience failed to create',
      personaSuccessfullyCreated: 'Audience successfully created',
      tryAgainAndIfTheError: 'Try again and if the error persists contact support',
      viewPersona: 'View audience',
      viewProgress: 'View progress',
    },
    useEditPersonaForm: {
      failedToUpdatePersona: 'Failed to update audience',
      personaSavedButSharingWas: 'Audience saved, but sharing was not updated',
      personaSuccessfullyUpdated: 'Audience successfully updated',
      pleaseFixTheErrorsInThe: 'Please fix the errors in the form',
      pleaseFixTheFollowing: 'Please fix the following: {{fields}}',
      tryAgainAndIfTheError: 'Try again and if the error persists contact support',
      yourChangesToWhoCan: 'Your changes to who can access it were not applied',
    },
    useProfileMediaTab: {
      couldnTGenerateThe: "Couldn't generate the {{label}}",
      couldnTGenerateTheImage: "Couldn't generate the image",
      couldnTGenerateTheVideos: "Couldn't generate the videos",
      detailVideo: 'detail video',
      failedToUploadImage: 'Failed to upload image',
      seeTheMessageOnEachVideo: 'See the message on each video for what to change.',
      thumbnailVideo: 'thumbnail video',
      tryAgainAndIfTheError: 'Try again and if the error persists contact support',
    },
    useVisibilityOptions: {
      allUsersUnderOrganization:
        'All users under {{organizationName}} organization will have access to this audience',
      allUsersUnderYourOrganization:
        'All users under your organization will have access to this audience',
      onlyUsersUnderWorkspace:
        'Only users under {{workspaceName}} workspace will have access to this audience',
      onlyUsersUnderYourWorkspace:
        'Only users under your workspace will have access to this audience',
      chooseWhichWorkspaces:
        'Choose which workspaces in your organization will have access to this audience',
      organization: 'Organization',
      specifiedWorkspaces: 'Specified workspaces',
      workspace: 'Workspace',
    },
    workspacesField: {
      onlyUsersInSelectedWorkspaces:
        'Only users in the selected workspaces will have access to this audience.',
    },
    videoCard: {
      couldnTGenerateThisVideo: "Couldn't generate this video",
      created: 'Created {{createdAt}}',
      noVideo: 'No video',
      promptUsed: 'Prompt used',
      tryAgain: 'Try again',
    },
    videoSection: {
      detailVideo: 'Detail video',
      generateThumbnailAndDetailVideos:
        'Generate thumbnail and detail videos based on the profile image',
      generateVideos: 'Generate videos',
      generating: 'Generating...',
      noVideosGeneratedYet: 'No videos generated yet',
      reGenerateVideo: 'Re-generate video',
      thumbnailDetailVideo: 'Thumbnail & Detail video',
      thumbnailVideo: 'Thumbnail video',
    },
  },
  focusGroup: {
    focusGroupFormStore: {
      defaultTitle: 'Focus Group - {{date}}',
    },
    focusGroupPreview: {
      extractingKeyProjectInformation:
        'Extracting key project information from your uploaded documents.<br />This may take a moment.',
      generatedQuestions: 'Generated Questions',
      hideConfigurationPanel: 'Hide configuration panel',
      noFocusGroupReportGenerated: 'No focus group report generated yet',
      onceYouSetUpYour:
        "Once you set up your configuration in the left panel you'll see the results here.",
      runningFocusGroupGeneratingReport: 'Running Focus Group & Generating Report',
      showConfigurationPanel: 'Show configuration panel',
    },
    focusGroupReport: {
      downloadReport: 'Download report',
      failedToDownloadReport: 'Failed to download report',
      focusGroup: 'focus group',
      focusGroupConfiguration: 'Focus group configuration',
      focusGroupNotFound: 'Focus group not found.',
      newFocusGroup: 'New focus group',
      preparingYourDownloadThisMay: 'Preparing your download, this may take a moment…',
      saveToProject: 'Save to project',
      toggleConfigurationPanel: 'Toggle configuration panel',
      yourReportIsReady: 'Your report is ready',
    },
    focusGroupReportContent: {
      brandContextUnavailable: 'The linked analysis could not be read; run without brand context.',
      commonThemes: 'Common Themes',
      completeConversationHistoryWithAll: 'Complete conversation history with all participants',
      divergentViews: 'Divergent Views',
      executiveSummary: 'Executive summary',
      executiveSummary2: 'Executive Summary',
      individualInsights: 'Individual Insights',
      runWithBrandContext: 'Run with brand context from the {{brandName}} analysis',
      runWithBrandContextFromAnalysis: 'Run with brand context from the linked analysis',
      insight: 'Insight',
      interviews: 'Interviews',
      keyInsights: 'Key Insights',
      moderator: 'Moderator',
      noExecutiveSummaryAvailableYet: 'No executive summary available yet.',
      noInterviewDataAvailable: 'No interview data available.',
      notableQuotes: 'Notable Quotes',
      recommendations: 'Recommendations',
      researchTopic: 'Research topic',
      topInsights: 'Top Insights',
      transcriptsPerPersona: 'Transcripts per persona',
      transcriptsPerQuestion: 'Transcripts per question',
    },
    generatingQuestionsLoading: {
      generatingInterviewQuestions: 'Generating interview questions',
    },
    newFocusGroupLayout: {
      back: 'Back',
      cancel: 'Cancel',
      failedToGenerateQuestions: 'Failed to generate questions',
      focusGroupConfiguration: 'Focus group configuration',
      next: 'Next',
      retry: 'Retry',
      runFocusGroup: 'Run Focus Group',
    },
    reviewQuestionsStep: {
      removeQuestion: 'Remove question {{question}}',
      addQuestion: 'Add question',
      editAddOrRemoveQuestions: 'Edit, add, or remove questions before running the focus group',
      questionNumber: 'Question {{questionNumber}}',
      reviewQuestions: 'Review Questions',
    },
    runStep: {
      analyzingProjectGoalsAndObjectives: 'Analyzing project goals and objectives',
      done: 'Done',
      generatingReport: 'Generating report...',
      notStarted: 'Not Started',
      report: 'Report',
      respondingToQuestion: 'Responding to question {{currentQuestion}}/{{totalQuestions}}...',
      runAndGenerateResults: 'Run and generate results',
    },
    setupStep: {
      brandContextFromAnalysis: 'Brand context from the {{brandName}} analysis',
      brandName: 'Brand name',
      brandOrProductToBe: 'Brand or product to be studied',
      describeYourResearchGoalAnd:
        'Describe your research goal and select the personas you want answers from',
      enterQuestions: 'Enter questions',
      selectPersonasToInterview: 'Select Personas to Interview',
      titleFromAnalysis: '{{brandName}} - focus group',
      whatWouldYouLikeTo: 'What would you like to explore in this focus group?',
      focusGroupTitle: 'Focus Group Title',
      setupYourFocusGroup: 'Setup your Focus Group',
    },
    stepLabels: {
      reviewQuestions: 'Review questions',
      runAndGenerate: 'Run and generate',
      setupResearch: 'Setup research',
    },
    useRunFocusGroup: {
      focusGroupExecutionFailed: 'Focus group execution failed',
      noResponseStreamAvailable: 'No response stream available',
      participant: 'Participant',
      requestFailedWithStatus: 'Request failed with status {{status}}',
      streamConnectionLost: 'Stream connection lost',
    },
  },
  focusGroupWidget: {
    focusGroupThumbnail: {
      participantCount_one: '{{count}} participant',
      participantCount_other: '{{count}} participants',
    },
  },
  focusGroups: {
    conductLiveInterviewsWithYour: 'Conduct live interviews with your personas',
    focusGroupRowActions: {
      delete: 'Delete',
      edit: 'Edit',
      focusGroupActions: 'Focus group actions',
    },
    focusGroups: 'Focus Groups',
    focusGroupsContent: {
      actions: 'Actions',
      couldNotDeleteFocusGroup: 'Could not delete focus group.',
      createFocusGroup: 'Create Focus Group',
      filterByOwner: 'Filter by owner',
      filterByStatus: 'Filter by status',
      focusGroupDeleted: 'Focus group deleted.',
      name: 'Name',
      newFocusGroup: 'New focus group',
      noResultsFor: 'No results for “{{search}}”',
      owner: 'Owner',
      scheduleALiveInterviewTo:
        'Schedule a live interview to uncover real-time feedback directly from your personas.',
      searchFocusGroups: 'Search focus groups',
      startTheConversation: 'Start the conversation',
      status: 'Status',
      thisActionCannotBeUndone:
        'This action cannot be undone. The focus group and its results will be removed.',
      totalInterviewed: 'Total Interviewed',
      untitled: 'Untitled',
    },
    status: {
      cancelled: 'Cancelled',
      pending: 'Pending',
    },
  },
  persona: {
    getPersonaFetchErrorMessage: {
      somethingWentWrongWhileLoading: 'Something went wrong while loading audiences. Try again.',
    },
    personaCard: {
      personaActions: 'Persona actions',
      profileImage: 'Profile image - {{name}}',
      unnamedPersona: 'Unnamed persona',
    },
  },
  personaSpark: {
    sentiment: {
      negative: 'Negative',
      neutral: 'Neutral',
      positive: 'Positive',
    },
    sparkCard: {
      opportunity: 'Opportunity',
      startChat: 'Start chat',
      viewOpportunity: 'View opportunity',
    },
  },
  personaSparks: {
    controlButton: {
      icon: 'icon',
    },
    sparkCarousel: {
      nextSpark: 'Next spark',
      previousSpark: 'Previous spark',
    },
  },
} as const;
